'use client';

import React from 'react';
import { cn } from '~/lib/utils';

type Props = {
  className?: string;
};

export default function BreakpointDebugger({ className }: Props) {
  const [show, setShow] = React.useState(true);

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  if (!show) {
    return null;
  }

  return (
    <button
      className={cn(
        className,
        'fixed z-50 overflow-hidden rounded-md px-1',
        'bg-red-500/75 text-white',
        'sm:bg-orange-500/75',
        'md:bg-yellow-500/75',
        'lg:bg-green-500/75',
        'xl:bg-blue-500/75',
        '2xl:bg-purple-500/75',
      )}
      onClick={() => setShow(false)}
    >
      <div className="sm:hidden">XS</div>
      <div className="hidden sm:block md:hidden">SM 640+</div>
      <div className="hidden md:block lg:hidden">MD 768+</div>
      <div className="hidden lg:block xl:hidden">LG 1024+</div>
      <div className="hidden xl:block 2xl:hidden">XL 1280+</div>
      <div className="hidden 2xl:block">2XL 1536+</div>
    </button>
  );
}
